/* eslint-disable react/prop-types */
import React from 'react';
import '../Style/Qualifications.css';

function Qualifications() {
  const qualifications = [
    {
      name: '丙種危険物取扱免状',
      date: '令和2年 04月　',
      org: '　主催:一般財団法人消防試験研究センター',
    },
    {
      name: '情報処理技術者認定試験 2級',
      date: '令和4年 07月　',
      org: '　主催:サーティファイ情報処理能力認定委員会',
    },
    {
      name: 'Microsoft Office Specialist Word365&2019',
      date: '令和4年 09月　',
      org: '　主催:Microsoft',
    },
    {
      name: 'Microsoft Office Specialist PowerPoint365&2019',
      date: '令和5年 07月　',
      org: '　主催:Microsoft',
    },
    {
      name: 'Webクリエイター認定試験スタンダード',
      date: '令和5年 10月　',
      org: '　主催:サーティファイWeb利用・技術認定委員会',
    },
    {
      name: '基本情報技術者試験',
      date: '令和6年 05月　',
      org: '　主催:IPA 独立行政法人 情報処理推進機構',
    },
  ];

  //const learning = [];

  return (
    <div className="qualifications-container">
      <Section title="取得済みの資格・免許" items={qualifications} />
      {/* <Section title="学習中の資格" items={learning} /> */}
    </div>
  );
}

function Section({ title, items }) {
  return (
    <section className="qualifications-section">
      <h2 className="qualifications-title">{title}</h2>
      <div className="qualification-list">
        {items.map((item, index) => (
          <div key={`${item.name}-${index}`} className="qualification-item">
            <span className="qualification-date">{item.date}</span>
            <span className="qualification-name">{item.name}</span>
            <span className="qualification-organization">{item.org}</span>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Qualifications;
